import React, { FC, useMemo } from 'react';
import { UserType } from 'api/models/core-types';
import { useUserType } from './use-user-type';

type ControlType = 'show' | 'hide';

interface Props {
  userType: UserType;
  controlType: ControlType;
}

const shouldRender =
  (type: ControlType, userType: UserType) => (currentUserType: UserType) => {
    switch (type) {
      case 'show':
        return currentUserType === userType;
      case 'hide':
        return currentUserType !== userType;
      default:
        return false;
    }
  };

export const ControlBasedOnUserType: FC<Props> = ({
  userType,
  controlType,
  children,
}) => {
  const currentUserType = useUserType();
  const shouldRenderChildren = useMemo(
    () => shouldRender(controlType, userType)(currentUserType),
    [controlType, userType, currentUserType],
  );

  return shouldRenderChildren ? <>{children}</> : null;
};
